// Module
var code = "<template> <require from=\"app/cd/components/contact-log/contact-log\"></require> <contact-log member-id.bind=\"member.id\" target-id.bind=\"authId\" contact-log-config.bind=\"contactLogConfig\"></contact-log> </template> ";
// Exports
module.exports = code;